import React from 'react';

import ArticlePreview from '@buyside/components/presentation/Feed/ArticlePreview/articlePreview';
import Button, { BUTTON_TYPES, BUTTON_SIZES } from '@buyside/components/presentation/Button/button';
import FeedHeading from '@buyside/components/presentation/Feed/FeedHeading/feedHeading';
import PostOptions from '@buyside/components/presentation/Feed/PostOptions/postOptions';
import CommentBodyRenderer from '@buyside/components/presentation/CommentBodyRenderer/commentBodyRenderer';
import YouTubePlayer from '@buyside/components/presentation/YouTubePlayer/youtubePlayer';

import { postUrl } from '@buyside/util/urlHelper';

import { ActivityFeedPostFragment } from '@interfaces/graphql-typings';
import { FeedItemComponentType } from '@interfaces/feed/feedItems';

import styles from './postStyles.scss';

const Post: React.FC<{
  post: ActivityFeedPostFragment;
} & FeedItemComponentType> = ({ post, feedItemId, currentUser, eventVerb }): React.ReactElement => {
  const canDelete = currentUser && post.user?.id === currentUser.id;

  return (
    <div>
      <div className={styles.feedItemHeader}>
        <FeedHeading
          createdAt={post?.postedAt}
          headerType={eventVerb}
          showUserDetails={Boolean(currentUser?.canViewUserDetails || canDelete)}
          user={post.user}
          idea={null}
        />
        {canDelete && <PostOptions feedItemId={feedItemId} headerType={eventVerb} />}
      </div>
      <div className={styles.postContent} id={`${post.id}-post`}>
        <div className={styles.postText}>
          <CommentBodyRenderer body={post.body} />
        </div>
        <Button
          text="Read More"
          type={BUTTON_TYPES.PRIMARY}
          size={BUTTON_SIZES.SMALL}
          url={postUrl(post.id)}
        />
        {post.youtubeId ? (
          <YouTubePlayer height={351} videoId={post.youtubeId} />
        ) : (
          <ArticlePreview
            ogUrl={post.ogUrl || ''}
            ogTitle={post.ogTitle}
            ogDescription={post.ogDescription}
            ogPreviewImageUrl={post.ogPreviewImageUrl}
            domain={post.domain}
          />
        )}
      </div>
    </div>
  );
};

export default Post;
